import styled from 'styled-components';

const Anchor = styled.a`
  color: ${(props) => props.theme.colors.primary};
`;
export default Anchor;
